import gql from 'graphql-tag';

export const CANCEL_ORDER_MUTATION = gql`
mutation cancelOrder($id: ID!) {
  cancelOrder(input: { id: $id }) {
    success
  }
}
`;

export const CREATE_EXPENSE_MUTATION = gql`
mutation ExpenseCreate($expenseInput: ExpenseInput!) {
  expenseCreate(input: {expenseInput: $expenseInput}) {
    expense {
      id
      totalAmount
      taxAmount
      issuedOn
      dueOn
      number
      notes
      hasVat
      contactId
      currency
      totalAmount
    }
  }
}
`;

export const CREATE_ORDER_MUTATION = gql`
mutation createOrder($subscriptionPlanId: ID!, $paymentMethod: String!) {
  createOrder(input: { subscriptionPlanId: $subscriptionPlanId, paymentMethod: $paymentMethod }) {
    success,
    flash,
    redirectTo
  }
}
`;

export const CREATE_USER_MUTATION = gql`
mutation UserCreate($userInput: UserInput!) {
  userCreate(input: {userInput: $userInput}) {
    user {
      id
      email
      name
      emailsAccepted
      role
    }
  }
}
`;

export const DELETE_EXPENSE_MUTATION = gql`
mutation expenseDelete($id: ID!) {
  expenseDelete(input: { id: $id }) {
    success
  }
}
`;

export const DELETE_USER_MUTATION = gql`
mutation userDelete($id: ID!) {
  userDelete(input: { id: $id }) {
    success
  }
}
`;
export const EMAIL_SETTINGS_UPDATE = gql`
mutation ($thankYouBody: String!, $thankYouSubject: String!, $documentBody: String!, $documentSubject: String!, $reminderBody: String!, $reminderSubject: String!) {
  settingUpdate(
    input: {
      settingInput: {
        thankYouBody: $thankYouBody,
        thankYouSubject: $thankYouSubject
        documentBody: $documentBody
        documentSubject: $documentSubject
        reminderBody: $reminderBody
        reminderSubject: $reminderSubject
      }
    }
  ) {
    success,
    errors,
    setting {
      id,
      thankYouBody,
      thankYouSubject,
      documentBody,
      documentSubject,
      reminderBody,
      reminderSubject
    }
  }
}
`;

export const EVENT_LOG_MUTATION = gql`
mutation logEvent($event: String!) {
  logEvent(input: { event: $event }) {
    success
  }
}
`;

export const EXPENSE_BATCH_DOWNLOAD_ATTACHMENTS_MUTATION = gql`
mutation ExpenseAttachmentDownload($ids: [ID!]!) {
  expenseAttachmentDownload(input: { ids: $ids }) {
    success
    redirectTo
  }
}
`;

export const EXPENSE_PAY_MUTATION = gql`
mutation expensePay($id: ID!, $paidAt: String) {
  expensePay(input: { id: $id, paidAt: $paidAt }) {
    expense {
      id
      state
      number
      dueOn
      issuedOn
      paid
      paidAt
      totalAmount
      contact {
        id
        name
      }
    }
  }
}
`;

export const INVOICE_BATCH_DOWNLOAD_MUTATION = gql`
mutation invoiceBatchDownload($ids: [ID!]!, $exportType: InvoiceFormatEnum!) {
  invoiceBatchDownload(input: { ids: $ids, exportType: $exportType }) {
    success,
    jobId
  }
}
`;
export const INVOICE_BATCH_SUBMIT_MUTATION = gql`
mutation invoiceBatchSubmit($email: String!, $url: String!) {
  invoiceBatchSubmit(input: { email: $email, url: $url }) {
    success,
  }
}
`;

export const INVOICE_PRINT_MUTATION = gql`
mutation logInvoicePrint($id: ID!) {
  logInvoicePrint(input: { id: $id }) {
    success
  }
}
`;

export const REMOVE_UNIT_MUTATION = gql`
mutation removeUnit($unit: String!) {
  removeUnit(input: { unit: $unit }) {
    units
  }
}
`;

export const SUBMIT_CONTACT_MUTATION = gql`
mutation contactForm($email: String!, $message: String!) {
  contactForm(input: { email: $email, message: $message }) {
    success
  }
}
`;

export const SUBMIT_SURVEY_MUTATION = gql`
mutation surveyCreate($surveyInput: SurveyInput!) {
  surveyCreate(input: { surveyInput: $surveyInput }) {
    success
  }
}
`;

export const THANK_YOU_MUTATION = gql`
mutation hideThankYouPage {
  hideThankYouPage(input: {}) {
    subscription {
      id,
      showThankYouPage,
      activeUntil,
      lastPeriod {
        id,
        paymentType,
        planName
      }
    }
  }
}
`;

export const UPDATE_BILLING_MUTATION = gql`
mutation BillingUpdate($id: ID!, $billingInput: BillingInput!) {
  billingUpdate(input: {id: $id, billingInput: $billingInput}) {
    success
  }
}
`;

export const UPDATE_EXPENSE_MUTATION = gql`
mutation ExpenseUpdate($id: ID!, $expenseInput: ExpenseInput!) {
  expenseUpdate(input: {id: $id, expenseInput: $expenseInput}) {
    expense {
      id
      totalAmount
      taxAmount
      issuedOn
      dueOn
      number
      notes
      hasVat
      contactId
      currency
      totalAmount
    }
  }
}
`;

export const UPDATE_SEQUENCE_MUTATION = gql`
mutation SequenceUpdate($id: ID!, $sequenceInput: SequenceInput!) {
  sequenceUpdate(input: {id: $id, sequenceInput: $sequenceInput}) {
    sequence {
      id
      expenseSequenceFormat
      invoiceSequenceFormat
      taxCorrectionSequenceFormat
      expenseSequenceNumber
      invoiceSequenceNumber
      taxCorrectionSequenceNumber
      nextInvoiceNumber,
      currentInvoiceNumber,
      nextExpenseNumber,
      currentExpenseNumber
    }
  }
}
`;

export const UPDATE_USER_MUTATION = gql`
mutation UserUpdate($id: ID!, $userInput: UserInput!) {
  userUpdate(input: {id: $id, userInput: $userInput}) {
    user {
      id
      email
      name
      emailsAccepted
      role
    }
  }
}
`;
